export const getDraftShareIdFromQueryParam = (): string => {
	return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
